import { useEffect } from 'react'

const useAssetModal = (assetSchemaKey, showModal, assetData, schema, sectionSettings, setAssetTypes, setSelectedAssetType) => {
  useEffect(() => {
    if (!assetSchemaKey || !showModal) return
    let assets = schema[assetSchemaKey]
      .filter(field => !field.rpmType || assetData) // filter out assets that are sourced from rpm unless its a legacy unsynced asset
      .map(field => ({ ...field, label: field.displayName || field.type, value: field.type }))
    
    // apply field visibility settings
    assets = assets.map(asset => {
      const visibilitySettings = sectionSettings?.assets?.find(({type}) => type === asset.type)
      const assetFields = asset.fields.map(assetField => {
        const fieldVisibilitySetting = visibilitySettings?.fields.find(_field => _field.id === assetField.id)
        assetField['visible'] = fieldVisibilitySetting?.visible
        return assetField
      })
      asset.fields = assetFields
      return asset
    })
    setAssetTypes(assets)
    setSelectedAssetType(assetData ? assets.find(_ => _.type === assetData.type) : assets[0])
  }, [assetSchemaKey, showModal, assetData, schema, sectionSettings, setAssetTypes, setSelectedAssetType])
}

export { useAssetModal }